import axios from "axios";
import store from './../index'

export default {
  state: {
    workloads: null,
  },
  getters: {
    WORKLOADS: state => {
      return state.workloads;
    },
  },
  mutations: {
    SET_WORKLOADS: (state, payload) => {
      state.workloads = payload;
    },
  },
  actions: {
    GetWorkloadDescription: (commit, payload) => {
        return new Promise((resolve, reject) => {
            axios
                .get(`/Price/GetWorkloadByPriceId?priceId=` + payload)
                .then(({
                    data,
                    status
                }) => {
                    if (status === 200) { 
                        window.console.log('workload',data);
                        store.commit('SET_WORKLOADS', data);
                        resolve(data);
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
  },
};